import { Fragment, useEffect, useState } from "react";
import { getData } from "../../../api/ApiRest";
import LoadingComponent from "../../../widgets/LoadingComponent";
import { FaMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";
import { formatNumber } from "../../../widgets/FormatNumber";
import { formatDateddMMMyyyy } from "../../../widgets/DateTime";
import { FloatingLabel, Form, Modal } from "react-bootstrap";

function ClientesVinculados() {
    const [loading, setLoading] = useState(false);
    const [registros, setRegistros] = useState([]);
    const [registrosMes, setRegistrosMes] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);

    const [modalConteo, setModalConteo] = useState({
        ModalVisible: false, Titulo: '', Mes: '', Year: ''
    });

    const [dataBuscar, setDataBuscar] = useState({
        tipoReporte: 'R'
    });

    useEffect(() => {
        visualizarClientes('R');

        setDataBuscar({
            tipoReporte: 'R'
        });
    }, []);

    const visualizarClientes = (tipoReporte) => {
        setLoading(true);

        getData('api/Configuracion/Reporte/getClientesVinculados', {
            tipoReporte: tipoReporte
        }).then(response => {
            setRegistros(response.clienteAgrupado);
            setRegistrosMes(response.clienteMes);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    let agrupado = {};

    if (Array.isArray(registros) && registros.length > 0) {
        agrupado = registros.reduce((acc, item) => {
            if (!acc[item.identificacion]) {
                acc[item.identificacion] = [];
            }

            acc[item.identificacion].push(item);
            return acc;
        }, {});
    }

    const toggleMostrarHijos = (nit) => {
        setExpandedRows(prev => ({
            ...prev,
            [nit]: !prev[nit]
        }));
    };

    const sumatoriaTotal = (nit) => {
        let total = 0;

        registros.filter(x => x.identificacion === nit).map(item => {
            total += item.valor;
        })

        return total;
    }

    const sumatoriaTotalGlobal = () => {
        let total = 0;

        registros.map(item => {
            total += item.valor;
        })

        return total;
    }

    const years = registrosMes ? [...new Set(registrosMes.map(item => item.year))] : [];

    const matriz = {};
    const totalesMes = {};

    if (Array.isArray(registrosMes) && registrosMes.length > 0) {
        registrosMes.forEach(item => {
            if (!matriz[item.mes]) {
                matriz[item.mes] = {};
            }

            if (!matriz[item.mes][item.year]) {
                matriz[item.mes][item.year] = 0;
            }

            matriz[item.mes][item.year] += 1;
        });
    }

    if (Array.isArray(registrosMes) && registrosMes.length > 0) {
        registrosMes.forEach(item => {
            if (!totalesMes[item.mes]) {
                totalesMes[item.mes] = {};
            }

            if (!totalesMes[item.mes][item.year]) {
                totalesMes[item.mes][item.year] = 0;
            }

            totalesMes[item.mes][item.year] += item.valor;
        });
    }


    const totalesPorYear = {};

    years.forEach(year => {
        totalesPorYear[year] = 0;
    });

    Object.values(matriz).forEach(meses => {
        years.forEach(year => {
            totalesPorYear[year] += meses[year] || 0;
        });
    });

    const totalesMonetariosPorYear = {};

    years.forEach(year => {
        totalesMonetariosPorYear[year] = 0;
    });

    Object.values(totalesMes).forEach(meses => {
        years.forEach(year => {
            totalesMonetariosPorYear[year] += meses[year] || 0;
        });
    });

    const Meses = [
        { key: '1', value: 'Enero' },
        { key: '2', value: 'Febrero' },
        { key: '3', value: 'Marzo' },
        { key: '4', value: 'Abril' },
        { key: '5', value: 'Mayo' },
        { key: '6', value: 'Junio' },
        { key: '7', value: 'Julio' },
        { key: '8', value: 'Agosto' },
        { key: '9', value: 'Septiembre' },
        { key: '10', value: 'Octubre' },
        { key: '11', value: 'Noviembre' },
        { key: '12', value: 'Diciembre' }
    ];

    const sumatoriaPorMes = (mes, year) => {
        let total = 0;

        registrosMes.filter(x => Number(x.mes) === Number(mes) && Number(x.year) === Number(year)).map(item => {
            total += item.valor;
        })

        return total;
    }

    return <div className='BodyComponent'>
        {<LoadingComponent Loading={loading} />}

        <div className="row">
            <div className="col-md-2">
                <FloatingLabel
                    controlId='TipoNewInput'
                    label="Tipo"
                    className="form-floating-sm"
                >
                    <Form.Select
                        className="input-fecha-sm"
                        value={dataBuscar.tipoReporte}
                        onChange={(event) => {
                            setDataBuscar({
                                tipoReporte: event.target.value
                            });

                            visualizarClientes(event.target.value);
                        }}
                    >
                        <option value="R">Global</option>
                        <option value="D">Detallado</option>
                    </Form.Select>
                </FloatingLabel>
            </div>
        </div>

        {dataBuscar.tipoReporte === 'R' && registros && registrosMes ? <div className='table-responsive mt-2'>
            <table className='table table-borderless table-hover'>
                <thead>
                    <tr>
                        <th className="estilo-encabezado"></th>
                        <th className="estilo-encabezado">
                            Cliente
                        </th>
                        <th className="estilo-encabezado">
                            Fecha vinculación
                        </th>
                        <th className="estilo-encabezado">
                            Total
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(agrupado).map(([nit, items]) => {
                        const valorPinta = String(registros.filter(x => x.identificacion === nit)[0].activo);

                        return (
                            <Fragment key={nit}>
                                <tr>
                                    <td className="text-center" style={{ backgroundColor: (String(valorPinta) != 'true') ? '#F8BEC3' : 'transparent', fontSize: 12 }}>
                                        <button className="btn btn-sm btn-primary" onClick={() => toggleMostrarHijos(nit)} style={{ fontSize: 10 }}>
                                            {expandedRows[nit] ? <FaMinus /> : <FaPlus />}
                                        </button>
                                    </td>
                                    <td className="text-center" style={{ backgroundColor: (String(valorPinta) != 'true') ? '#F8BEC3' : 'transparent', fontSize: 12 }}>
                                        {nit} - {registros.filter(x => x.identificacion === nit)[0].nombreAlterno}
                                    </td>
                                    <td className="text-center" style={{ backgroundColor: (String(valorPinta) != 'true') ? '#F8BEC3' : 'transparent', fontSize: 12 }}>
                                        {formatDateddMMMyyyy(registros.filter(x => x.identificacion === nit)[0].vinculacion)}
                                    </td>
                                    <td style={{ textAlign: 'right', backgroundColor: (String(valorPinta) != 'true') ? '#F8BEC3' : 'transparent', fontSize: 12 }}>
                                        $ {formatNumber(sumatoriaTotal(nit))}
                                    </td>
                                </tr>

                                {expandedRows[nit] &&
                                    items.map((item, i) => (
                                        <tr key={`${nit}-${i}`}>
                                            <td></td>
                                            <td className="text-center" style={{ fontSize: 12 }}>{item.year}</td>
                                            <td className="text-center" style={{ fontSize: 12 }}>{item.plan}</td>
                                            <td style={{ textAlign: 'right', fontSize: 12 }}>$ {formatNumber(item.valor)}</td>
                                        </tr>
                                    ))}
                            </Fragment>
                        )
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <th></th>
                        <th></th>
                        <th style={{ textAlign: 'center' }}>
                            Total
                        </th>
                        <th style={{ textAlign: 'right' }}>
                            $ {formatNumber(sumatoriaTotalGlobal())}
                        </th>
                    </tr>
                </tfoot>
            </table>
        </div> : null}

        {dataBuscar.tipoReporte === 'D' && registros && registrosMes ? <div className='table-responsive mt-2'>
            <table className='table table-borderless table-hover'>
                <thead>
                    <tr>
                        <th className="estilo-encabezado" rowSpan={2}>Mes</th>
                        {years.map(year => (
                            <th className="estilo-encabezado" colSpan={2} key={year}>{year}</th>
                        ))}
                    </tr>
                    <tr>
                        {years.map((anio, i) => (
                            <Fragment key={`sub-${i}`}>
                                <th className="estilo-encabezado">Núm clientes</th>
                                <th className="estilo-encabezado">Total</th>
                            </Fragment>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(matriz).map((mes, index) => {
                        return (
                            <tr key={index}>
                                <td style={{ textAlign: 'center', fontSize: 12 }}>{Meses.filter(c => Number(c.key) === Number(mes))[0].value}</td>

                                {years.map((year, i) => (
                                    <Fragment key={i}>
                                        <td style={{ textAlign: 'center', cursor: 'pointer', fontSize: 12 }} key={year} onClick={() => {
                                            setModalConteo({
                                                ModalVisible: true,
                                                Titulo: Meses.filter(c => Number(c.key) === Number(mes))[0].value + " - " + year,
                                                Mes: mes,
                                                Year: year
                                            });
                                        }}>
                                            {matriz[mes][year] || 0}
                                        </td>
                                        <td style={{ textAlign: 'right', fontSize: 12 }} key={year}>
                                            $ {formatNumber(totalesMes[mes][year] || 0)}
                                        </td>
                                    </Fragment>
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <th className="text-center">Total</th>
                        {years.map((year, i) => (
                            <Fragment key={i}>
                                <th style={{ textAlign: 'center' }}>
                                    {formatNumber(totalesPorYear[year])}
                                </th>
                                <th style={{ textAlign: 'right' }}>
                                    $ {formatNumber(totalesMonetariosPorYear[year])}
                                </th>
                            </Fragment>
                        ))}
                    </tr>
                </tfoot>
            </table>
        </div>
            : null}


        <Modal
            show={modalConteo.ModalVisible}
            size="lg"
            onHide={() => {
                setModalConteo({
                    ModalVisible: false, Titulo: '', Mes: '', Year: ''
                });
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalConteo.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {registrosMes ? <div className="row">
                    <table className='table table-borderless table-hover'>
                        <thead>
                            <tr>
                                <th className="estilo-encabezado">
                                    #
                                </th>
                                <th className="estilo-encabezado">
                                    Cliente
                                </th>
                                <th className="estilo-encabezado">
                                    Valor
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {registrosMes.filter(x => x.mes == modalConteo.Mes && x.year == modalConteo.Year).map((item, index) => (
                                <tr key={index}>
                                    <td className="text-center" style={{ fontSize: 12 }}>
                                        {index + 1}
                                    </td>
                                    <td className="text-center" style={{ fontSize: 12 }}>
                                        {item.identificacion} - {item.nombreAlterno}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: 12 }}>
                                        $ {formatNumber(item.valor)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th></th>
                                <th></th>
                                <th style={{ textAlign: 'right' }}>
                                    $ {formatNumber(sumatoriaPorMes(modalConteo.Mes, modalConteo.Year))}
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div> : null}

            </Modal.Body>
        </Modal>

    </div>
}

export default ClientesVinculados;